export { UserAvatar } from './UserAvatar'
export type { UserAvatarIProps, UserAvatarSize } from './UserAvatar'

export { OperatorAvatar, AI_OPERATOR_NAME } from './OperatorAvatar'
export type { OperatorAvatarIProps } from './OperatorAvatar'
